/*
 * Vibee money formatting — tek yardımcı (P59).
 *   vibeeMoney(cents)        → "479,90 TL"  (Shopify format / TR fallback)
 *   vibeeMoneyFloor(cents)   → "1.001 TL"   (hesaplanan tutarlar: Math.floor, kuruşsuz)
 * Dağınık toFixed(2) kullanmayın; her yerde bu fonksiyonları çağırın.
 */
(function () {
  function trThousands(n) {
    var s = String(Math.max(0, Math.floor(Number(n) || 0)));
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  window.vibeeMoney = function (cents, format) {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format || window.Shopify.money_format);
    }
    var tl = Number(cents || 0) / 100;
    var whole = Math.floor(tl);
    var frac = Math.round((tl - whole) * 100);
    return trThousands(whole) + ',' + (frac < 10 ? '0' : '') + frac + ' TL';
  };

  window.vibeeMoneyFloor = function (cents) {
    return trThousands(Math.floor(Number(cents || 0) / 100)) + ' TL';
  };

  /** Tam TL tutarları kuruşsuz ("117 TL"); kesirli fiyatlar Shopify formatında. */
  window.vibeeMoneyDisplay = function (cents, format) {
    cents = Number(cents || 0);
    if (cents % 100 === 0) return window.vibeeMoneyFloor(cents);
    return window.vibeeMoney(cents, format);
  };
})();
